var render = function render(){
  var _vm$applications, _vm$applications2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "stage2content"
  }, [((_vm$applications = _vm.applications) === null || _vm$applications === void 0 ? void 0 : _vm$applications.length) !== 0 ? _c('div', {
    staticClass: "result-block-broker-app stage2"
  }, [_vm._m(0), _vm._l(_vm.applications, function (application, index) {
    return application.stage !== 'zrusena' ? _c('mortgage-application-sign-item', {
      key: index,
      attrs: {
        "application": application
      }
    }) : _vm._e();
  })], 2) : _vm._e(), ((_vm$applications2 = _vm.applications) === null || _vm$applications2 === void 0 ? void 0 : _vm$applications2.length) == 0 ? _c('div', {
    staticClass: "emptybox"
  }, [_c('span', {
    staticClass: "blc-color MGright20px"
  }, [_vm._v("Aby sa Vám zobrazil generátor žiadostí, je potrebné vybrať aspoň jednu banku pre klienta v prvom kroku VÝBER")])]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "results-legend signed"
  }, [_c('div', {
    staticClass: "break-40px"
  }), _c('div', {
    staticClass: "text-small wrap-100px"
  }, [_vm._v(" ÚVER ")]), _c('div', {
    staticClass: "text-small wrap-100px"
  }, [_vm._v(" SAZBA ")]), _c('div', {
    staticClass: "text-small wrap-50px"
  }, [_vm._v(" SPLÁTKA ")]), _c('div', {
    staticClass: "text-small wrap-50px"
  }, [_vm._v(" POPLATOK ")]), _c('div', {
    staticClass: "text-small wrap-100px"
  }, [_vm._v(" SPLATNOSŤ ")]), _c('div', {
    staticClass: "text-small wrap-50px"
  }, [_vm._v(" FIX ")])]);

}]

export { render, staticRenderFns }